namespace Vit {
    export interface CombogridColumn {
        field: string;
        name?: string;
        primary?: boolean;
        visible?: boolean;
        disabled?: boolean;
        // children?: Array<any>;
        source?: any;
    }

    export namespace CombogridConverter {
        export function toCombogridColumns(items: Array<CombogridColumn>) {
            return items.map((item: CombogridColumn) => toCombogridColumn(item));
        }

        export function toCombogridColumn(col: CombogridColumn): CombogridColumn {
            let column: CombogridColumn = {
                field: col.field,
                visible: (col.visible == null) ? true : !!col.visible,
            };

            if (col.primary) {
                column.primary = col.primary;
            }

            const title = Q.tryGetText(col.name);

            if (title) {
                column.name = title;
            }

            if (col.disabled == false) {
                column.disabled = false;
            }

            return column;
        }
    }
}